import { useCollection } from "./useCollection"

export const useMaster = (collection, form, parentCollection = true) => {

    const validateMaster = (master) => {
        const nodeForm = useCollection().getCollectionNode(form, collection, parentCollection)
        if (!master) return [false]
        const results = []
        master.forEach(m => {
            const [parentName, condition, result] = m.split('||')
            if (!nodeForm) results.push(false)
            else {
                const parent = nodeForm[parentName]?.toString() || form[parentName]?.toString()
                // if (parentName === 'taskEndTime') console.log(parentName, condition, parent, parent !== null && parent !== undefined, parent !== null, parent !== undefined)
                switch (condition) {
                    case 'eq':
                        results.push(parent === result)
                        break
                    case 'ne':
                        results.push(parent !== result)
                        break
                    case 'gt':
                        results.push(parent > result)
                        break
                    case 'gte':
                        results.push(parent >= result)
                        break
                    case 'lt':
                        results.push(parent < result)
                        break
                    case 'lte':
                        results.push(parent <= result)
                        break
                    case 'in':
                        results.push(result?.includes(parent))
                        break
                    case 'nin':
                        results.push(!result?.includes(parent))
                        break
                    case 'isnull':
                        results.push(parent === null || parent === undefined)
                        break
                    case 'notnull':
                        results.push(parent !== null && parent !== undefined)
                        break
                    case 'between':
                        results.push(parent > result[0] && parent < result[1])
                        break
                    default:
                        results.push(parent === result)
                        break
                }
            }
        })

        return results.every(v => v === true)
    }

    return { validateMaster }
}
